module.exports = __webpack_public_path__ + "static/img/index_btn_2.b3545dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_btn_2.png
// module id = ppnc
// module chunks = 1